{
    "removedInvoicedatesList": [],
    "removedInvoicedatesTotalCount": 0,
    "removedInvoicedatesSortExpression": null,
    "removedInvoicedatesFilterExpression": null,
    "removedInvoicedatesPaging": {
      "offset": 50,
      "page": 1
    },
    "currentColumns": [
      "chassisNumber",
      "serialNumber",
      "productIndividualNumber",
      "invoicedDate",
      "country",
      "updatedBy",
      "reasonOfRemoval"
  ]
}